export enum RiskLevel {
  lowRisk = 'low',
  mediumRisk = 'medium',
  highRisk = 'high',
  managedHighRisk = 'managedHigh',
}

export type DefaultRiskLevel = RiskLevel.lowRisk | RiskLevel.mediumRisk | RiskLevel.highRisk;

export const DefaultRiskLevels = [
  RiskLevel.lowRisk,
  RiskLevel.mediumRisk,
  RiskLevel.highRisk,
] as const;
